import type { DeckStudyCard } from "@-/dev.improve.haniverse.lib.cards";
import type { CardFilterMorphemeKind } from "@-/dev.improve.haniverse.lib.cards.filter";

/**
 * The deck row a study card belongs to: its subject text plus whether that subject is a character
 * or a word.
 */
export type DeckStudyCardSubject = { kind: CardFilterMorphemeKind; text: string };

/**
 * Words and characters share the deck, so a row is NOT always a grapheme. Returning the kind
 * alongside the text is what lets the caller skip grapheme-only work (card-filter facts, which are
 * keyed by grapheme and do not exist for a word) instead of silently dropping word cards — which
 * is exactly what a previous grapheme-only accessor did.
 */
export function deckStudyCardSubject(studyCard: DeckStudyCard): DeckStudyCardSubject | undefined {
  const grapheme =
    studyCard.userGraphemeMeaningCard?.grapheme ??
    studyCard.userGraphemePronunciationCard?.grapheme;
  if (grapheme !== undefined) {
    return { kind: "grapheme", text: grapheme };
  }
  const word = studyCard.userWordSentenceCard?.word;
  return word === undefined ? undefined : { kind: "word", text: word };
}
